import React, {useRef, useState, useCallback} from 'react'
import {Box as ChakraBox} from '@chakra-ui/react3'
import {motion, useInView, useReducedMotion} from 'framer-motion'
import PropTypes from 'prop-types'

const MotionBox = motion(ChakraBox)

const Fade = ({children, delay = 0.075, translateY = 0, trigger}) => {
    const [visibleOnLoad, setVisibleOnLoad] = useState(false)
    const boxRef = useRef(null)
    const reducedMotionEnabled = useReducedMotion()
    const Box = reducedMotionEnabled ? ChakraBox : MotionBox

    const hidden = {opacity: 0, y: translateY}
    const visible = {opacity: 1, y: 0}

    // Element must be 200px inside viewport before animation starts
    // (not just touching the edge - ensures it's clearly visible)
    const isInView = useInView(boxRef, {margin: `0px 0px -200px 0px`, once: true})

    const refCallback = useCallback((element) => {
        if (element) {
            const rect = element.getBoundingClientRect()
            const isVisible = rect.top < window.innerHeight && rect.bottom > 0
            setVisibleOnLoad(isVisible)
            boxRef.current = element
        }
    }, [])

    // If trigger is provided, use it; otherwise use viewport detection
    const shouldAnimate = trigger !== undefined ? trigger : isInView || visibleOnLoad

    return (
        <Box
            ref={refCallback}
            initial={hidden}
            animate={shouldAnimate ? visible : hidden}
            transition={{duration: 1.2, delay, ease: [0.44, 0, 0.56, 1]}}
        >
            {children}
        </Box>
    )
}

Fade.propTypes = {
    children: PropTypes.node.isRequired,
    delay: PropTypes.number,
    translateY: PropTypes.number,
    trigger: PropTypes.bool
}

export default Fade
